import { OwnerTransfer } from '@sorare/core/src/__generated__/globalTypes';
import { Shards } from '@sorare/core/src/atoms/icons/Shards';
import type { unitMapping } from '@sorare/core/src/lib/style';

import { Auction } from 'components/transfers/Auction';
import { InstantBuy } from 'components/transfers/InstantBuy';
import { Pack } from 'components/transfers/Pack';
import { ReferralReward } from 'components/transfers/ReferralReward';
import { Reward } from 'components/transfers/Reward';
import { Transfer } from 'components/transfers/Transfer';

type Props = {
  transferType: OwnerTransfer;
  size?: keyof typeof unitMapping;
};

export const TokenTransferTypeIcon = ({ transferType, size = 2 }: Props) => {
  switch (transferType) {
    case OwnerTransfer.REFERRAL:
      return <ReferralReward size={size} />;
    case OwnerTransfer.REWARD:
      return <Reward size={size} />;
    case OwnerTransfer.SHARDS:
      return <Shards size={size} color="var(--c-green-400)" />;
    case OwnerTransfer.PACK:
    case OwnerTransfer.BUNDLED_ENGLISH_AUCTION:
      return <Pack size={size} color="var(--c-blue-300)" />;
    case OwnerTransfer.ENGLISH_AUCTION:
      return <Auction size={size} color="var(--c-blue-300)" />;
    case OwnerTransfer.INSTANT_BUY:
      return <InstantBuy size={size} color="var(--c-blue-300)" />;
    default:
      return <Transfer size={size} />;
  }
};
